import { render, staticRenderFns } from "./Product1101001000011ogvtn.vue?vue&type=template&id=55ea5876"
import script from "./Product1101001000011ogvtn.vue?vue&type=script&lang=js"
export * from "./Product1101001000011ogvtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ea5876')) {
      api.createRecord('55ea5876', component.options)
    } else {
      api.reload('55ea5876', component.options)
    }
    module.hot.accept("./Product1101001000011ogvtn.vue?vue&type=template&id=55ea5876", function () {
      api.rerender('55ea5876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1101001000011ogvtn.vue"
export default component.exports